// copied from https://unpkg.com/fbjs@0.8.17/lib/memoizeStringOnly.js

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function memoizeStringOnly(callback: (key: string) => any) {
  var cache: { [key: string]: any } = {};
  return function (string: string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(null, string);
    }
    return cache[string];
  };
}

export default memoizeStringOnly;
